"use client";

import { useState } from "react";

export type UseModalReturn = ReturnType<typeof useModal>;

export function useModal(defaultState = false) {
	const [open, setOpen] = useState(defaultState);

	function onClose() {
		setOpen(false);
	}

	function onToggle() {
		setOpen((prev) => !prev);
	}

	return {
		open: open,
		toggle: onToggle,
		close: onClose,
		props: {
			open: open,
			onOpenChange: onClose,
		} as const,
	} as const;
}
